import type { EApiSortType } from '@/api/apiConstants'

const groupPrefix = createApiRoute(ApiModule.WAREHOUSE, ApiDataModel.MONITORING, 'dead-letter')

export const apiMonitoring = {
	fetchDeadLetterMessages: async (
		filters?: IDeadLetterFilters,
		pagination?: { page: number; perPage: number },
		sort?: Record<string, EApiSortType>,
	): Promise<IDeadLetterMessagesResponse> => {
		const { data, meta } = await apiCommon<IDeadLetterMessage[]>(groupPrefix, {
			method: 'GET',
			...createQuery(
				pagination ?? undefined,
				{
					operation: filters?.operation ?? undefined,
					date_from: filters?.dateFrom ?? undefined,
					date_to: filters?.dateTo ?? undefined,
					search: filters?.search ?? undefined,
				},
				sort,
			),
		})

		return {
			data: data.map(DeadLetterMessage),
			operations: DeadLetterOperationOptions((meta as unknown as IDeadLetterFiltersMeta)?.filters),
			meta,
		}
	},

	retryDeadLetterMessage: async (messageId: string): Promise<void> => {
		await apiCommon(`${groupPrefix}/${messageId}/retry`, {
			method: 'POST',
		})
	},
}
